import { FormControl, Grid, InputLabel, MenuItem, TextField } from "@mui/material";
import Button from '@mui/material/Button';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';




import Box from '@mui/material/Box';
import Select from "react-select";


import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import React, { useEffect, useRef, useState } from 'react'

import Folder from "@mui/icons-material/Folder";
import { TreeItemProps, TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import { styled } from '@mui/material/styles';
// import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import { Button, IconButton, Switch } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL, HOMEPAGE, generateRandomId } from "../constants";
import { useSearchParams } from "react-router-dom";



const CopyCourseMaterial = ({ fileIconMap, folderInfo, setOpenModal, openModal, title, lesson_id, forSelfStudyingPurposes }) => {
    const [searchParams] = useSearchParams();
    const sectionId = searchParams.get('sectionId')


    const submitButtonText = "Copy";
    const selectedCourse_initial = "Nothing"
    const [selectedCourse, setSelectedCourse] = React.useState(sectionId ?? selectedCourse_initial)
    const [dataLoaded, setDataLoaded] = React.useState(false)
    const [distinationFolderId, setDistinationFolderId] = React.useState(null);

    const options_initial = [
        {
            value: selectedCourse_initial,
            label: selectedCourse_initial
        }
    ]
    const [options, setOptions] = React.useState(options_initial)

    const onSubmitFunction = (e) => {
        e.preventDefault();

        let randID = generateRandomId(8);
        if (selectedCourse == selectedCourse_initial)
            Swal.fire("Make sure to select a course", "", "error");
        else {

            const sent_folder = {
                "id": randID,
                "name": title,
                "driveid": `${HOMEPAGE}/lessonsview${forSelfStudyingPurposes ? "sl" : ""}/${lesson_id}`,
                "parent_id": distinationFolderId,
                "type": "video",
                "group_id": selectedCourse,
                "course_id": "518",
                "isdeleted": false,
                "randId": randID,
                "isactive": true
            }

            // giveNewIdFolder(sent_folder, "", selectedCourse)

            setOpenModal(false);
            Swal.showLoading();
            axios.post(
                `${BASE_URL}/course/copyfiletocourse.php`,
                {
                    section_id: selectedCourse,
                    courseMaterials: sent_folder,
                    // sectionId: sectionId,
                    distinationFolderId: distinationFolderId,
                }
            )
                .then((res) => {

                    Swal.fire("Copied Successfully", "", "success")
                })
                .catch((err) => {

                    Swal.fire("Process Failed", "", "error");
                });
        }

    };

    const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
        color: theme.palette.text.secondary,
        [`& .${treeItemClasses.content}`]: {
            color: theme.palette.text.secondary,
            borderTopRightRadius: theme.spacing(2),
            borderBottomRightRadius: theme.spacing(2),
            paddingRight: theme.spacing(1),
            fontWeight: theme.typography.fontWeightMedium,
            '&.Mui-expanded': {
                fontWeight: theme.typography.fontWeightRegular,
            },
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
            '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
                backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
                color: 'var(--tree-view-color)',
            },
            [`& .${treeItemClasses.label}`]: {
                fontWeight: 'inherit',
                color: 'inherit',
            },
        },
        [`& .${treeItemClasses.group}`]: {
            marginLeft: 0,
            [`& .${treeItemClasses.content}`]: {
                paddingLeft: theme.spacing(2),
            },
        },
    }));


    function StyledTreeItem(props) {

        let mode = "folder"
        const {
            bgColor,
            color,
            labelIcon: LabelIcon,
            labelInfo,
            labelText,

            fileItem,
            ifFolder,
            ...other
        } = props;
        let fileIcon = Folder
        let iconcolor = 'inherit'
        if (!ifFolder) {


            if (fileIconMap?.hasOwnProperty(fileItem?.type.toLowerCase())) {
                fileIcon = fileIconMap[fileItem?.type.toLowerCase()].iconText
                iconcolor = fileIconMap[fileItem?.type.toLowerCase()].color
            } else {
                fileIcon = fileIconMap?.fallback.iconText
            }
            mode = "file"
        }
        let InfoContent = ''
        if (ifFolder) {
            let subfoldersCount = 0
            let subfilesCount = 0
            subfoldersCount = fileItem?.childrenfolders?.filter((folder) => folder.isdeleted == false)?.length
            subfilesCount = fileItem?.childrenfiles?.filter((file) => file.isdeleted == false).length
            mode = "folder"

            InfoContent = `${subfoldersCount} ${"folders"}, ${subfilesCount} ${"files"}`
        }

        console.log(props.id)
        return (

            <StyledTreeItemRoot
                itemId={props.id}
                label={
                    <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0, pl: 0.5 }} className="ar-direction"

                    >
                        <Box component={fileIcon} color={iconcolor} sx={{ mr: 1 }} />
                        <Typography variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1 }}
                            onClick={(e) => {
                                if (!ifFolder) {
                                    // e.stopPropagation()
                                    // handleDocumentLink(fileItem)
                                }
                            }}
                        >
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit" style={{ marginLeft: '10px' }}>
                            {InfoContent}
                        </Typography>
                    </Box>

                }
                style={{
                    color: color,
                    background: bgColor,
                }}
                {...other}
            />
        );
    }





    const RenderFolderContent = (folder) => {

        if (!folder) {
            return null
        }
        return (



            ("type" in folder) ? null :
                !folder?.isdeleted
                    ? <StyledTreeItem id={folder.id} key={folder?.id + folder?.parent_id} nodeId={folder?.id?.toString()} fileItem={folder} labelText={folder.name} labelIcon={Folder} ifFolder={true}
                        onClick={(e) => {

                            setDistinationFolderId(folder?.id)
                        }}
                    >
                        {folder?.childrenfolders?.length > 0 && (
                            <div className="en-folder-padding ar-folder-padding" style={{ paddingLeft: '20px' }}>
                                {folder?.childrenfolders?.map((childFolder, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {!childFolder?.isdeleted
                                                ? <div> {RenderFolderContent(childFolder)}</div>
                                                : null}
                                        </React.Fragment >
                                    )
                                }
                                )}
                            </div>
                        )}
                    </StyledTreeItem>
                    : null

        )
    }

    const fetchData = async () => {
        Swal.showLoading()
        const response = await axios.post(`${BASE_URL}/course/getcourses.php`, {
            sectionId,
            enroll_type: 'teacher'
        })


        const json = response.data.data
        setOptions((o) => {
            return [
                ...options_initial,
                ...json.map((c) => {
                    const x = {
                        value: c.coursegroup_id,
                        label: c.name,
                    };
                    if (c.hasOwnProperty("user") && c.user) {
                        x.user = c.user;
                    }
                    return x;
                })]
        })
        Swal.close()
    }


    useEffect(() => {
        if (openModal) {
            fetchData()
        }
    }, [])

    const [courseMaterials, setCourseMaterials] = React.useState(undefined);
    React.useEffect(() => {
        if (selectedCourse !== undefined && selectedCourse !== null && selectedCourse_initial !== selectedCourse) {
            Swal.showLoading();
            axios.get(`${BASE_URL}/course/getcoursemat.php?section_id=${selectedCourse}`)
                .then((res) => {
                    if (res?.data?.data?.hasOwnProperty("course_materials_json")) {
                        let jsondata = res.data.data.course_materials_json

                        if (jsondata) {
                            setCourseMaterials(JSON.parse(jsondata));
                        } else {
                            setCourseMaterials([]);
                        }
                        setDataLoaded(true)
                    }
                    Swal.close();
                })
                .catch((err) => {

                    Swal.fire("Process Failed", "", "error");
                });
        }
    }, [selectedCourse]);


    return (
        <>
            <br />
            <form onSubmit={onSubmitFunction}>
                <Grid container spacing={3}>
                    <Grid item sm={12} style={{ color: '#2260af' }}>
                        <div style={{ zIndex: 5000000 }}>

                            <FormControl fullWidth >
                                <div>Choose a Course</div>
                                <Select
                                    // menuPosition="fixed"
                                    labelId="course-select-label"
                                    id="course-select"
                                    label="Course"
                                    name="course"
                                    value={options.filter((opt) => opt.value == selectedCourse)}
                                    onChange={e => {
                                        // setSelectedOption(e)
                                        setSelectedCourse(e.value);
                                        setDistinationFolderId(null);
                                    }}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999999 }),
                                    }}
                                    menuPortalTarget={document.body}
                                    menuPosition='fixed'
                                    fullWidth
                                    options={options.map((c) => ({
                                        value: c.value,
                                        label: (
                                            <div className=" d-flex flex-column justify-content-center align-items-center "
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <div className=" d-flex flex-column justify-content-center align-items-center "
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {c.label ?? ""}
                                                </div>
                                                {
                                                    (c.hasOwnProperty("user") && c.user) ?
                                                        (
                    
                                                            <div className=" d-flex flex-column justify-content-center align-items-center "
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                ( {c.user} )
                                                            </div>
                                                        )
                                                        :
                                                        null
                                                }
                                            </div>
                                        )
                                    }))}
                                />


                                {
                                    selectedCourse_initial === selectedCourse ? null :
                                        <>
                                            <div
                                                style={{
                                                    padding: "5px",
                                                    margin: "5px",
                                                    marginTop: "20px",
                                                    border: "#0c50a7 1px solid",
                                                    borderRadius: "10px",
                                                }}
                                            >
                                                {
                                                    dataLoaded ?

                                                        <SimpleTreeView
                                                            aria-label="Course Folder Tree"
                                                            defaultExpanded={[]}
                                                            defaultCollapseIcon={<ArrowDropDownIcon />}
                                                            defaultExpandIcon={<ArrowRightIcon />}
                                                            defaultEndIcon={<div style={{ width: 24 }} />}
                                                            sx={{ height: 'auto', flexGrow: 1, maxWidth: 800, overflowY: 'auto' }}
                                                        >
                                                            {courseMaterials.length > 0
                                                                ? courseMaterials.map((folder, index) => {

                                                                    return (
                                                                        <div key={index} id={index} > {RenderFolderContent(folder)}</div>
                                                                        // <div></div>
                                                                    )
                                                                })
                                                                : <>{"No Folders"}</>
                                                            }

                                                        </SimpleTreeView>

                                                        :

                                                        <div>Loading</div>
                                                }
                                            </div>
                                            {
                                                distinationFolderId ?
                                                    <Button className="ar-btn-icon-mr" fullWidth variant='contained' endIcon={<FolderOpenIcon />}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setDistinationFolderId(null);
                                                        }}
                                                    >
                                                        {"Set the root as the distination"}
                                                    </Button>
                                                    :
                                                    <h3 className=" text-center " >Root is the distination</h3>
                                            }
                                        </>
                                }
                            </FormControl>

                        </div>
                    </Grid>
                    <Grid item sm={12} style={{ color: '#2260af' }}>

                    </Grid>
                    <Grid item sm={12}>
                        <Button className="ar-btn-icon-mr" fullWidth variant='contained' type='submit' value="submit" endIcon={<FolderOpenIcon />}>
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

export default CopyCourseMaterial;